import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import { useMyOrderDetailQuery } from '@/entities/order';
import { useBankTransferQuery } from '@/entities/payment';
import { useAbandonBankTransfer } from '@/features/bank-transfer';
import { useCancelOrder } from '@/features/order-cancel';
import { SitePageShell } from '@/shared/ui';
import { OrderDeposit } from '@/widgets/order-deposit';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 계좌이체 입금 안내 페이지 — 주소의 주문 id 를 해석해 결제·주문 조회와 쓰기 훅을 입금 안내 위젯에 잇는다. */
export const OrderDepositPage = (): ReactElement => {
  const { orderId = '' } = useParams();
  const parsed = normalizedUuidSchema.safeParse(orderId);
  const id = parsed.success ? parsed.data : '';
  const transfer = useBankTransferQuery(id, { enabled: parsed.success });
  const order = useMyOrderDetailQuery(id, { enabled: parsed.success });
  const abandon = useAbandonBankTransfer();
  const cancel = useCancelOrder();
  return (
    <SitePageShell header={<SiteHeader />} footer={<SiteFooter />}>
      <div className="flex flex-col gap-10">
        <h1 className="text-3xl font-bold">입금 안내</h1>
        {parsed.success ? (
          <OrderDeposit
            orderId={id}
            transfer={transfer}
            order={order}
            abandon={abandon}
            cancel={cancel}
          />
        ) : (
          <p role="alert">주문을 찾을 수 없습니다.</p>
        )}
      </div>
    </SitePageShell>
  );
};
